/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { saveAs } from "file-saver";

/** Common Components */
import Buttons from '../../../components/ui/button/Buttons';
import CardSection from '../../../components/ui/card/CardSection';
import FormCreator from '../../../components/finalForms/FormCreator';

/** Utilities */
import formatDate from '../../../lib/formatDate';
import { getDropdownValue } from '../../../lib/getDropdownValue';
import { FieldSettingType } from '../../../utils/Enums/commonEnums';
import { setFieldSetting } from '../../../utils/FormFields/FieldsSetting/SetFieldSetting';
import { setDropdownOptions } from '../../../components/finalForms/libs/mapDropdownOptions';

/** RTK Query */
import {
  useGroupManagementListMutation,
  useLazyExportTimesheetReportListByGroupWiseQuery
} from '../../../app/services/groupManagementAPI';
import { useLazyGetGroupMemberByGroupIdQuery } from '../../../app/services/groupMemberAPI';
import { useLazyGetGroupProjectsByGroupIdQuery } from '../../../app/services/groupProjectAPI';

/** Common Services & Data Files */
import ToastService from '../../../services/toastService/ToastService';

/** Configuration Files */
import { groupWiseReportsConfig } from './config/GroupWiseReports.data';

const GroupWiseReports = () => {
  const groupWiseReportsFormRef = useRef();

  const [groupWiseReportsData, setGroupWiseReportsData] = useState({ ...groupWiseReportsConfig });

  const [getGroupList, {
    isSuccess: isGroupListSuccess,
    data: groupListData
  },] = useGroupManagementListMutation();

  const [getGroupMemberByGroupId, {
    isFetching: isGroupMemberByGroupIdLoading,
    isSuccess: isGroupMemberByGroupIdSuccess,
    data: GroupMemberByGroupIdData
  },] = useLazyGetGroupMemberByGroupIdQuery();

  const [getGroupProjectsByGroupId, {
    isFetching: isGroupProjectsByGroupIdLoading,
    isSuccess: isGroupProjectsByGroupIdSuccess,
    data: groupProjectsByGroupIdData
  },] = useLazyGetGroupProjectsByGroupIdQuery();

  const [getDownloadFile, {
    isLoading: isExportFetching,
    isSuccess: isExportSucess,
    data: isExportData,
  },] = useLazyExportTimesheetReportListByGroupWiseQuery();

  useEffect(() => {
    getGroupmoduleList();
  }, [])

  useEffect(() => {
    if (isGroupListSuccess && groupListData) {
      const groupArray = groupListData.dataSource;
      setDropdownOptions(groupArray, 'groupId', 'groupName', groupWiseReportsData, 'groupName', setGroupWiseReportsData);
      setFieldSetting(groupWiseReportsData, 'groupName', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isGroupListSuccess, groupListData]);

  useEffect(() => {
    if (!isGroupMemberByGroupIdLoading && isGroupMemberByGroupIdSuccess && GroupMemberByGroupIdData) {
      setDropdownOptions(GroupMemberByGroupIdData, 'userId', 'userName', groupWiseReportsData, 'groupMember', setGroupWiseReportsData);
      setFieldSetting(groupWiseReportsData, 'groupMember', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isGroupMemberByGroupIdLoading, isGroupMemberByGroupIdSuccess, GroupMemberByGroupIdData])

  useEffect(() => {
    if (!isGroupProjectsByGroupIdLoading && isGroupProjectsByGroupIdSuccess && groupProjectsByGroupIdData) {
      setDropdownOptions(groupProjectsByGroupIdData, 'projectId', 'projectName', groupWiseReportsData, 'groupProject', setGroupWiseReportsData);
      setFieldSetting(groupWiseReportsData, 'groupProject', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isGroupProjectsByGroupIdLoading, isGroupProjectsByGroupIdSuccess, groupProjectsByGroupIdData,])

  useEffect(() => {
    if (!isExportFetching && isExportSucess && isExportData) {
      let file = new Blob([isExportData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (isExportData.size > 0) {
        saveAs(file, `Groupwise Report ${formatDate(new Date(), "DD-MM-YYYY")}`);
      }
      else {
        ToastService.error("No Record Found is Selected Date");
      }
    }
  }, [isExportFetching, isExportSucess, isExportData]);

  const getGroupmoduleList = () => {
    const request = {
      pagination: {
        pageNumber: 1,
        pageSize: 200,
      },
      filters: { searchText: '' },
    };
    getGroupList(request);
  };

  const handleGroupWiseFieldChange = (dataField, updatedFormData) => {
    if (dataField === 'groupName') {
      if (getDropdownValue(updatedFormData.groupName)) {
        const groupId = getDropdownValue(updatedFormData.groupName);
        getGroupMemberByGroupId(groupId);
        getGroupProjectsByGroupId(groupId);
      }
    }
  };

  const handleDownload = () => {
    const groupReportData = groupWiseReportsFormRef.current.getFormData();
    if (groupReportData) {
      const { groupName, groupMember, groupProject, dateRange } = groupReportData;

      const groupId = getDropdownValue(groupName);
      const memberIds = groupMember ? groupMember?.join(",") : null;
      const projectIds = groupProject ? groupProject?.join(",") : null;
      const startDate = dateRange.startDate ? formatDate(dateRange.startDate, "YYYY-MM-DD") : null;
      const endDate = dateRange.endDate ? formatDate(dateRange.endDate, "YYYY-MM-DD") : null;

      const exceldata = {
        groupId: groupId,
        groupMemberId: memberIds,
        groupProjectId: projectIds,
        startDate: startDate,
        endDate: endDate
      };
      getDownloadFile(exceldata);
    }
  };

  const handleClearFilter = () => {
    const form = { ...groupWiseReportsConfig }
    form.initialState = {
      ...groupWiseReportsConfig.initialState,
      groupName: null,
      groupMember: null,
      groupProject: null,
      dateRange: null,
    };
    setFieldSetting(groupWiseReportsData, 'groupMember', FieldSettingType.REMOVEFIELDOPTIONS, []);
    setFieldSetting(groupWiseReportsData, 'groupProject', FieldSettingType.REMOVEFIELDOPTIONS, []);
    setGroupWiseReportsData(form);
  };

  return (
    <div>
      <CardSection
        rightButton={false}
        buttonClassName="theme-btn"
        buttonText="Export"
        textWithIcon={false}
        iconName="material-symbols:add-rounded"
        fontIcon={false}
        searchInput={false}
        isShorting={false}
        customHeader={true}
        headerContentWrapper={
          <div className="task-grid-list">
            <div className="d-flex align-items-center">
              <div className="task-grid-card-title">Group Wise Reports</div>
            </div>
            <div className="d-flex justify-content-end gap-2">
              <Buttons
                buttonTypeClassName="btn-secondary"
                textWithIcon={true}
                fontIcon={true}
                iconName={'ic:round-clear'}
                buttonText="Clear"
                onClick={handleClearFilter}
              />
              {/* <Buttons
                buttonTypeClassName="btn theme-btn"
                textWithIcon={true}
                fontIcon={true}
                iconName={'material-symbols:search-rounded'}
                buttonText="Search"
              // onClick={() => handleGetRecord()}
              /> */}
              <Buttons
                buttonTypeClassName="success-btn"
                textWithIcon={true}
                fontIcon={true}
                iconName={'ph:export'}
                buttonText="Export"
                onClick={handleDownload}
              />
            </div>
          </div>
        }
      >
        <div className='input-label-part'>
          <FormCreator config={groupWiseReportsData} ref={groupWiseReportsFormRef} onColumnChange={handleGroupWiseFieldChange} />
        </div>
      </CardSection>
    </div>
  )
}

export default GroupWiseReports